/* Puff Korner · comportements partagés des sections style TealerLab.
   Tout est délégué au document : fonctionne aussi après un rechargement de section dans l'éditeur. */
(function () {
  if (window.__pgTl) return;
  window.__pgTl = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Carrousels : [data-tl] contient [data-tl-track], [data-tl-prev], [data-tl-next], [data-tl-dots] ---- */
  function step(track) {
    var first = track.children[0];
    if (!first) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
    return first.getBoundingClientRect().width + gap;
  }
  function sync(root) {
    var track = root.querySelector('[data-tl-track]'); if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    var p = root.querySelector('[data-tl-prev]'), n = root.querySelector('[data-tl-next]');
    if (p) p.disabled = track.scrollLeft <= 2;
    if (n) n.disabled = track.scrollLeft >= max;
    var dots = root.querySelector('[data-tl-dots]');
    if (dots) {
      var count = Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step(track)) + 1);
      if (dots.children.length !== count) { dots.innerHTML = ''; for (var i = 0; i < count; i++) dots.appendChild(document.createElement('i')); }
      var idx = Math.round(track.scrollLeft / step(track));
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('on', i === Math.min(idx, count - 1)); });
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tl-prev],[data-tl-next]'); if (!b) return;
    var root = b.closest('[data-tl]'), track = root && root.querySelector('[data-tl-track]'); if (!track) return;
    track.scrollBy({ left: (b.hasAttribute('data-tl-prev') ? -1 : 1) * step(track), behavior: reduce ? 'auto' : 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (!t.matches || !t.matches('[data-tl-track]')) return;
    var root = t.closest('[data-tl]'); if (root) sync(root);
  }, true);
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-tl]').forEach(sync);
    (scope || document).querySelectorAll('[data-tl-count]').forEach(watchCount);
    (scope || document).querySelectorAll('[data-tl-countdown]').forEach(countdown);
  }
  window.addEventListener('resize', function () { document.querySelectorAll('[data-tl]').forEach(sync); });

  /* ---- Compteurs animés ---- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); runCount(en.target); } });
  }, { threshold: .4 }) : null;
  function fmt(n, dec) { return n.toLocaleString('fr-FR', { minimumFractionDigits: dec, maximumFractionDigits: dec }); }
  function runCount(el) {
    var to = parseFloat(el.getAttribute('data-tl-count')) || 0, dec = (String(el.getAttribute('data-tl-count')).split('.')[1] || '').length;
    if (reduce) { el.textContent = fmt(to, dec); return; }
    var t0 = null, dur = 1600;
    function f(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3); el.textContent = fmt(to * k, dec); if (k < 1) requestAnimationFrame(f); }
    requestAnimationFrame(f);
  }
  function watchCount(el) { if (el.__tlc) return; el.__tlc = 1; if (io) io.observe(el); else runCount(el); }

  /* ---- Compte à rebours : data-tl-countdown="AAAA-MM-JJTHH:MM" ou "weekly:1" (reset chaque lundi) ---- */
  function nextTarget(v) {
    if (v.indexOf('weekly:') === 0) {
      var day = parseInt(v.split(':')[1], 10) || 1, d = new Date(); d.setHours(0, 0, 0, 0);
      var add = (day - d.getDay() + 7) % 7 || 7; d.setDate(d.getDate() + add); return d.getTime();
    }
    var t = Date.parse(v); return isNaN(t) ? 0 : t;
  }
  function countdown(el) {
    if (el.__tlcd) return; el.__tlcd = 1;
    var target = nextTarget(el.getAttribute('data-tl-countdown'));
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      if (!el.isConnected) return;
      var s = Math.max(0, Math.floor((target - Date.now()) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      el.textContent = (d ? d + 'j ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      if (s > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---- Ajout au panier : [data-tl-add] (data-id) ou [data-tl-add-many] (JSON) ---- */
  function addUrl() { return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js'; }
  window.pgTlAdd = function (items) {
    return fetch(addUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (c) { document.dispatchEvent(new CustomEvent('pg:cart:updated', { detail: c })); return c; });
  };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tl-add],[data-tl-add-many]'); if (!b || b.disabled) return;
    e.preventDefault();
    var items = b.hasAttribute('data-tl-add-many') ? JSON.parse(b.getAttribute('data-tl-add-many') || '[]') : [{ id: parseInt(b.getAttribute('data-id'), 10), quantity: 1 }];
    if (!items.length) return;
    var label = b.innerHTML; b.disabled = true;
    window.pgTlAdd(items).then(function () {
      b.classList.add('is-ok'); b.textContent = 'Ajouté ✓';
      setTimeout(function () { b.classList.remove('is-ok'); b.innerHTML = label; b.disabled = false; }, 1600);
    }).catch(function (err) {
      b.innerHTML = label; b.disabled = false;
      if (window.pgLxToast) window.pgLxToast((err && err.description) || 'Impossible d\'ajouter ce produit');
    });
  });

  /* ---- Carte produit : choix de la variante (select ou pastilles) ---- */
  function applyVariant(card, opt) {
    var btn = card.querySelector('[data-tl-add]');
    if (btn) { btn.setAttribute('data-id', opt.id); btn.disabled = !opt.ok; btn.textContent = opt.ok ? (btn.getAttribute('data-label') || '+ Ajouter') : 'Épuisé'; }
    var p = card.querySelector('[data-tl-price]'); if (p) p.textContent = opt.p;
    var c = card.querySelector('[data-tl-cmp]'); if (c) { c.textContent = opt.c || ''; c.hidden = !opt.c; }
    var u = card.querySelector('[data-tl-unit]'); if (u && opt.u) u.textContent = opt.u;
  }
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-tl-variant]'); if (!s) return;
    var o = s.options[s.selectedIndex];
    applyVariant(s.closest('[data-tl-card]'), { id: o.value, ok: !o.disabled, p: o.getAttribute('data-p'), c: o.getAttribute('data-c'), u: o.getAttribute('data-u') });
  });
  document.addEventListener('click', function (e) {
    var ch = e.target.closest('[data-tl-chip]'); if (!ch) return;
    var card = ch.closest('[data-tl-card]');
    card.querySelectorAll('[data-tl-chip]').forEach(function (x) { x.setAttribute('aria-pressed', x === ch ? 'true' : 'false'); });
    applyVariant(card, { id: ch.getAttribute('data-tl-chip'), ok: true, p: ch.getAttribute('data-p'), c: ch.getAttribute('data-c'), u: ch.getAttribute('data-u') });
  });

  /* ---- FAQ : recherche ---- */
  document.addEventListener('input', function (e) {
    var q = e.target.closest('[data-tl-faq-q]'); if (!q) return;
    var v = q.value.trim().toLowerCase(), root = q.closest('[data-tl-faq]'), shown = 0;
    root.querySelectorAll('[data-tl-faq-item]').forEach(function (it) {
      var ok = !v || it.textContent.toLowerCase().indexOf(v) > -1; it.hidden = !ok; if (ok) shown++;
    });
    var none = root.querySelector('[data-tl-faq-none]'); if (none) none.hidden = shown > 0;
  });

  /* ---- Boutons qui ouvrent la roue (pg-lx-popups) ---- */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-tl-wheel]'); if (!w) return;
    if (typeof window.pgLxOpenWheel === 'function') { e.preventDefault(); window.pgLxOpenWheel(); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  window.pgTlInit = initAll;
})();
